// export const environment = {
// //   //apiURL: 'http://localhost:3000/api/'
// apiURL: 'https://elixir-vprc-frontoffpos-stg-g2dea4hbe9f2g2a0.southindia-01.azurewebsites.net/api/'
// apiURL: 'https://elixir-vprc-frontoffpos-prod-hjgugae5f0bde0hp.southindia-01.azurewebsites.net/api/'
// };

const host = window.location.hostname;
// // // // // console.log('Host:', host); // Log the hostname to verify it's correct
const LOCAL_API = 'http://localhost:3000/api/';
const STG_API =
  'https://elixir-vprc-frontoffpos-stg-g2dea4hbe9f2g2a0.southindia-01.azurewebsites.net/api/';
const UAT_API =
  'https://elixir-vprc-frontoffpos-uat-c7fzhagwe3hadwca.southindia-01.azurewebsites.net/api/';
const PROD_API =
  'https://elixir-vprc-frontoffpos-prod-hjgugae5f0bde0hp.southindia-01.azurewebsites.net/api/';

// Known frontend hostnames, matched exactly
const apiByHost: Record<string, string> = {
  'localhost': LOCAL_API,
  'frontoff-stg.elixrretailpos.com': STG_API,
  'elixirfrontoffposuat-hke7aqfpebcmh2dk.z02.azurefd.net': UAT_API,
  'frontoff.elixrretailpos.com': PROD_API,
};

let apiURL = apiByHost[host];

// Fallback for hostnames not listed above
if (!apiURL) {
  if (host.includes('stg')) {
    apiURL = STG_API;
  } else if (host.includes('uat')) {
    apiURL = UAT_API;
  } else {
    apiURL = PROD_API;
  }
}

export const environment = {
  apiURL: apiURL,
  // Dashboard "Bill No" counter: how often to re-fetch the latest bill number (ms)
  // so sales on other counters show up. Used by BillNumberRefreshService.
  billNumberPollIntervalMs: 30000,
};
